<template>
  <div>
    <navBack title="入会须知"></navBack>
    <div class="zjxNotice">
      <div class="zxj_notice">
        <div class="zxj_notice__detail" v-html="join_paper"></div>
      </div>
    </div>
  </div>
</template>

<script>
import navBack from "../../components/navBack.vue";
import { getJoinPaper } from "../../api/moudles/user.js";
export default {
  data() {
    return {
      join_paper: "",
    };
  },
  components: {
    navBack,
  },
  created() {
    this.getJoinPaper();
  },
  methods: {
    // 获取入会须知
    async getJoinPaper() {
      await getJoinPaper({
        success: (res) => {
          this.join_paper = res.data.joinPaper;
        },
      });
    },
  },
};
</script>

<style scoped>
>>> .zxj_notice__detail > p > img,
.zxj_notice__detail > img,
.zxj_notice__detail > span > img {
  max-width: 100% !important;
  height: 100% !important;
}

@media screen and (max-width: 750px) {
  .zxj_notice {
    width: 100%;
    min-height: 650px;
    background-color: #fff;
    padding-bottom: 60px;
  }
}

@media screen and (min-width: 750px) {
  .zxj_notice {
    width: 1200px;
    min-height: 650px;
    background-color: #fff;
  }
}

.zjxNotice {
  min-height: 710px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.zxj_notice__title {
  width: 90%;
  margin-left: 5%;
  height: 70px;
  font-size: 24px;
  font-weight: 600;
  text-align: center;
  line-height: 70px;
  border-bottom: 1px solid #f5f5f5;
}

.zxj_notice__other {
  height: 50px;
  line-height: 50px;
  width: 80%;
  margin-left: 10%;
  display: flex;
  justify-content: space-evenly;
}

.zxj_notice__other > span {
  font-size: 14px;
  color: #d3d3d3;
}

.zxj_notice__detail {
  margin-top: 20px;
  width: 90%;
  margin-left: 5%;
}
</style>
